function normalizeBase(url) {
  return (url || "").trim().replace(/\/$/, "");
}

function isLocalDevApi(url) {
  if (!url) {
    return true;
  }

  try {
    const { hostname } = new URL(url);
    return hostname === "localhost" || hostname === "127.0.0.1";
  } catch {
    return false;
  }
}

/** When the production bundle was built with a dev API URL, derive the public API host. */
function productionApiFallback() {
  if (typeof window === "undefined") {
    return "";
  }

  const { hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "";
  }

  const root = hostname.replace(/^www\./i, "");
  return `https://api.${root}`;
}

function resolveApiBase() {
  const fromEnv = normalizeBase(
    process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL
  );

  if (fromEnv && !isLocalDevApi(fromEnv)) {
    return fromEnv;
  }

  const fallback = productionApiFallback();
  if (fallback) {
    return fallback;
  }

  return fromEnv;
}

function getApiBase() {
  return resolveApiBase();
}

function mapLeadToApi(formData) {
  return {
    fullName: formData.full_name,
    email: formData.email,
    phone: formData.phone,
    companyName: formData.company_name,
    serviceNeeded: formData.service_needed,
    budgetRange: formData.budget_range,
    projectDetails: formData.project_details,
  };
}

function parseErrorMessage(response, bodyText) {
  try {
    const json = JSON.parse(bodyText);
    if (json.detail) return String(json.detail);
    if (json.title) return String(json.title);
    if (json.errors) {
      return Object.values(json.errors).flat().join(", ");
    }
  } catch {
    // not JSON
  }
  return bodyText || `Request failed (${response.status})`;
}

export async function submitContactLead(formData) {
  const apiBase = getApiBase();
  if (!apiBase) {
    throw new Error(
      "API URL is not configured. Set REACT_APP_API_URL in frontend/.env (e.g. http://localhost:5022)."
    );
  }

  const response = await fetch(`${apiBase}/api/leads`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(mapLeadToApi(formData)),
  });

  const bodyText = await response.text();

  if (response.status === 429) {
    throw new Error(
      parseErrorMessage(response, bodyText) ||
        "Too many submissions. Please wait a moment and try again."
    );
  }

  if (!response.ok) {
    throw new Error(parseErrorMessage(response, bodyText));
  }

  return bodyText ? JSON.parse(bodyText) : { success: true };
}
